import "../css/styles.scss";

const checkIcon = '<i class="fa-solid fa-check text-success"></i>';
const xmarkIcon = '<i class="fa-solid fa-xmark text-danger"></i>';

$(() => checkSelection());

$("#lista").on("change", () => checkSelection());

const checkSelection = () => {
  switch ($("#lista").val()) {
    case "0": {
      $("#epossidica").html(checkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "1": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "2": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "3": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "4": {
      $("#epossidica").html(checkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(xmarkIcon);
      break;
    }
    case "5": {
      $("#epossidica").html(checkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "6": {
      $("#epossidica").html(checkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "7": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "8": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "9": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "10": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "11": {
      $("#epossidica").html(checkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "12": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "13": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "14": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "15": {
      $("#epossidica").html(checkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(xmarkIcon);
      break;
    }
    case "16": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "17": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "18": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(xmarkIcon);
      break;
    }
    case "19": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "20": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "21": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "22": {
      $("#epossidica").html(checkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "23": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(checkIcon);
      break;
    }
    case "24": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(xmarkIcon);
      break;
    }
    case "25": {
      $("#epossidica").html(xmarkIcon);
      $("#epossipoliestere").html(checkIcon);
      $("#poliestere").html(xmarkIcon);
      $("#poliuretanica").html(xmarkIcon);
      break;
    }
    case "26": {
      $("#epossidica").html(checkIcon);
      $("#epossipoliestere").html(xmarkIcon);
      $("#poliestere").html(checkIcon);
      $("#poliuretanica").html(xmarkIcon);
      break;
    }
  }
};
